/**
 * HVACPRIMESUPPLY - Main JavaScript
 * High-Converting Direct Checkout, Live Variant Price Switcher, Sticky Add to Cart & Interactive UI
 */

document.addEventListener('DOMContentLoaded', () => {
  // 1. Mobile Menu Drawer
  const mobileToggleButtons = document.querySelectorAll('.js-mobile-toggle');
  const mobileCloseButtons = document.querySelectorAll('.js-mobile-close');
  const mobileDrawer = document.getElementById('mobileDrawer');
  const mobileOverlay = document.querySelector('.mobile-drawer-overlay');

  function openMobileNav() {
    if (mobileDrawer) mobileDrawer.classList.add('open');
    if (mobileOverlay) mobileOverlay.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    if (mobileDrawer) mobileDrawer.classList.remove('open');
    if (mobileOverlay) mobileOverlay.style.display = 'none';
    document.body.style.overflow = '';
  }

  mobileToggleButtons.forEach(btn => btn.addEventListener('click', openMobileNav));
  mobileCloseButtons.forEach(btn => btn.addEventListener('click', closeMobileNav));

  // 2. Shopping Cart Drawer
  const cartTriggers = document.querySelectorAll('.js-cart-trigger');
  const cartCloseButtons = document.querySelectorAll('.js-cart-close');
  const cartDrawer = document.getElementById('cartDrawer');
  const cartOverlay = document.querySelector('.cart-drawer-overlay');

  function openCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.add('open');
      cartDrawer.setAttribute('aria-hidden', 'false');
    }
    if (cartOverlay) cartOverlay.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.remove('open');
      cartDrawer.setAttribute('aria-hidden', 'true');
    }
    if (cartOverlay) cartOverlay.style.display = 'none';
    document.body.style.overflow = '';
  }

  cartTriggers.forEach(btn => {
    btn.addEventListener('click', (e) => {
      if (!window.location.pathname.includes('/cart')) {
        e.preventDefault();
        openCartDrawer();
      }
    });
  });

  cartCloseButtons.forEach(btn => btn.addEventListener('click', closeCartDrawer));

  // 3. Quantity Selector Buttons (+ / -)
  const qtyDownBtn = document.querySelector('.js-qty-down');
  const qtyUpBtn = document.querySelector('.js-qty-up');
  const qtyInput = document.getElementById('quantity');

  if (qtyInput) {
    if (qtyDownBtn) {
      qtyDownBtn.addEventListener('click', () => {
        let current = parseInt(qtyInput.value, 10) || 1;
        if (current > 1) {
          qtyInput.value = current - 1;
        }
      });
    }
    if (qtyUpBtn) {
      qtyUpBtn.addEventListener('click', () => {
        let current = parseInt(qtyInput.value, 10) || 1;
        if (current < 99) {
          qtyInput.value = current + 1;
        }
      });
    }
  }

  // 4. Direct Instant "Buy Now • Proceed to Checkout" Handler
  const directCheckoutButtons = document.querySelectorAll('.js-direct-checkout, .btn-buy-now-direct');
  directCheckoutButtons.forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const originalText = btn.innerHTML;
      btn.innerHTML = '<span>Processing Secure Checkout...</span>';
      btn.disabled = true;

      const form = btn.closest('form') || document.querySelector('#product-form') || document.querySelector('form[action*="/cart/add"]');
      let variantId = null;
      let quantity = 1;

      const selectedVariantInput = document.getElementById('selectedVariantId');
      if (selectedVariantInput && selectedVariantInput.value) {
        variantId = selectedVariantInput.value;
      } else if (form) {
        const idInput = form.querySelector('input[name="id"], select[name="id"]');
        if (idInput) variantId = idInput.value;
      }

      if (form) {
        const qInput = form.querySelector('input[name="quantity"]');
        if (qInput) quantity = parseInt(qInput.value, 10) || 1;
      }

      if (variantId) {
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: quantity
            })
          });

          if (response.ok) {
            window.location.href = '/checkout';
            return;
          }
        } catch (err) {
          console.warn('Instant checkout AJAX error, fallback to /checkout', err);
        }
      }

      window.location.href = '/checkout';
    });
  });

  // 5. Dynamic Live Product Variant & Price Switcher
  const variantsJsonEl = document.getElementById('productVariantsJson');
  const variantSelects = document.querySelectorAll('.js-variant-select');
  const masterSelect = document.getElementById('productMasterSelect');
  const selectedVariantIdInput = document.getElementById('selectedVariantId');
  const productPriceEl = document.getElementById('productPrice');
  const productComparePriceEl = document.getElementById('productComparePrice');
  const productStockBadgeEl = document.getElementById('productStockBadge');
  const addToCartBtn = document.getElementById('addToCartBtn');
  const buyNowBtn = document.getElementById('buyNowBtn');
  const productMainImage = document.getElementById('productMainImage');

  let moneyFormat = '${{amount}}';
  const moneyFormatEl = document.getElementById('shopMoneyFormat');
  if (moneyFormatEl) {
    try {
      moneyFormat = JSON.parse(moneyFormatEl.textContent);
    } catch (e) {
      moneyFormat = '${{amount}}';
    }
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision === undefined ? 2 : precision;
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;

      if (isNaN(number) || number == null) return '0.00';
      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsVal = parts[1] ? (decimal + parts[1]) : '';
      return dollars + centsVal;
    }

    const match = formatString.match(placeholderRegex);
    if (!match) {
      return '$' + (cents / 100).toFixed(2);
    }

    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  if (variantsJsonEl) {
    try {
      const variants = JSON.parse(variantsJsonEl.textContent);

      function updateVariant() {
        let matchingVariant = null;

        if (variantSelects.length > 0) {
          const selectedOptions = Array.from(variantSelects).map(select => select.value.trim());

          matchingVariant = variants.find(variant => {
            return selectedOptions.every((optValue, index) => {
              const variantOptKey = 'option' + (index + 1);
              if (variant[variantOptKey] === undefined || variant[variantOptKey] === null) {
                return true;
              }
              const varVal = String(variant[variantOptKey]).trim();
              return varVal === optValue || varVal.toLowerCase() === optValue.toLowerCase();
            });
          });

          if (!matchingVariant && selectedOptions.length === 1) {
            const chosen = selectedOptions[0].toLowerCase();
            matchingVariant = variants.find(variant => {
              const vTitle = String(variant.title).toLowerCase();
              return vTitle === chosen || chosen.includes(vTitle) || vTitle.includes(chosen);
            });
          }
        }

        if (!matchingVariant && masterSelect && masterSelect.value) {
          matchingVariant = variants.find(v => String(v.id) === String(masterSelect.value));
        }

        if (matchingVariant) {
          if (selectedVariantIdInput) {
            selectedVariantIdInput.value = matchingVariant.id;
          }
          if (masterSelect) {
            masterSelect.value = matchingVariant.id;
          }

          if (productPriceEl) {
            productPriceEl.textContent = formatMoney(matchingVariant.price, moneyFormat);
            productPriceEl.setAttribute('data-price', matchingVariant.price);
          }

          if (productComparePriceEl) {
            if (matchingVariant.compare_at_price && matchingVariant.compare_at_price > matchingVariant.price) {
              productComparePriceEl.textContent = formatMoney(matchingVariant.compare_at_price, moneyFormat);
              productComparePriceEl.style.display = 'inline-block';
            } else {
              productComparePriceEl.style.display = 'none';
            }
          }

          if (matchingVariant.available) {
            if (productStockBadgeEl) {
              productStockBadgeEl.className = 'stock-status-pill in-stock';
              productStockBadgeEl.innerHTML = '<span class="stock-dot"></span> In Stock &bull; Ships in 1&ndash;2 Days';
            }
            if (addToCartBtn) {
              addToCartBtn.disabled = false;
              const textSpan = addToCartBtn.querySelector('span');
              if (textSpan) textSpan.textContent = 'ADD TO CART';
            }
            if (buyNowBtn) {
              buyNowBtn.style.display = 'block';
            }
          } else {
            if (productStockBadgeEl) {
              productStockBadgeEl.className = 'stock-status-pill sold-out';
              productStockBadgeEl.innerHTML = '<span class="stock-dot sold-out-dot"></span> Currently Sold Out';
            }
            if (addToCartBtn) {
              addToCartBtn.disabled = true;
              const textSpan = addToCartBtn.querySelector('span');
              if (textSpan) textSpan.textContent = 'SOLD OUT';
            }
            if (buyNowBtn) {
              buyNowBtn.style.display = 'none';
            }
          }

          if (matchingVariant.featured_image && matchingVariant.featured_image.src && productMainImage) {
            productMainImage.src = matchingVariant.featured_image.src;
          }

          if (window.history.replaceState) {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set('variant', matchingVariant.id);
            window.history.replaceState({ path: currentUrl.href }, '', currentUrl.href);
          }
        }
      }

      variantSelects.forEach(select => {
        select.addEventListener('change', updateVariant);
      });
      if (masterSelect) {
        masterSelect.addEventListener('change', updateVariant);
      }
    } catch (e) {
      console.warn('Could not initialize variant switcher:', e);
    }
  }

  // 6. Accordions (FAQ & Specifications)
  const accordionTriggers = document.querySelectorAll('.accordion-trigger');
  accordionTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion-item');
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

      trigger.setAttribute('aria-expanded', !isExpanded);
      if (item) {
        item.classList.toggle('active');
      }
    });
  });

  // 7. Sticky Add to Cart Bar on Scroll
  const stickyAtcBar = document.getElementById('stickyAtcBar');
  const mainBuyBox = document.querySelector('.purchase-cta-row');
  const stickyTriggerBtn = document.querySelector('.js-sticky-atc-trigger');

  if (stickyAtcBar && mainBuyBox) {
    window.addEventListener('scroll', () => {
      const rect = mainBuyBox.getBoundingClientRect();
      if (rect.bottom < 0) {
        stickyAtcBar.classList.add('visible');
        stickyAtcBar.setAttribute('aria-hidden', 'false');
      } else {
        stickyAtcBar.classList.remove('visible');
        stickyAtcBar.setAttribute('aria-hidden', 'true');
      }
    });

    if (stickyTriggerBtn) {
      stickyTriggerBtn.addEventListener('click', () => {
        const mainForm = document.getElementById('product-form');
        if (mainForm) {
          mainForm.requestSubmit ? mainForm.requestSubmit() : mainForm.submit();
        }
      });
    }
  }

  // 8. Cookie Consent Management
  const cookieBanner = document.getElementById('cookieBanner');
  const btnAccept = document.getElementById('acceptCookiesBtn');
  const btnNecessary = document.getElementById('necessaryCookiesBtn');

  if (cookieBanner) {
    const consent = localStorage.getItem('HVACPRIMESUPPLY_cookie_consent');
    if (!consent) {
      cookieBanner.style.display = 'block';
    }

    if (btnAccept) {
      btnAccept.addEventListener('click', () => {
        localStorage.setItem('HVACPRIMESUPPLY_cookie_consent', 'accepted_all');
        cookieBanner.style.display = 'none';
      });
    }

    if (btnNecessary) {
      btnNecessary.addEventListener('click', () => {
        localStorage.setItem('HVACPRIMESUPPLY_cookie_consent', 'necessary_only');
        cookieBanner.style.display = 'none';
      });
    }
  }

  // 9. Product Image Gallery Switcher
  const mainImage = document.getElementById('productMainImage');
  const thumbnails = document.querySelectorAll('.product-thumbnail-btn, .product-thumb');
  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbnails.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const newSrc = thumb.getAttribute('data-img-src');
      if (mainImage && newSrc) {
        mainImage.src = newSrc;
      }
    });
  });

  // 10. Route Fallback Title Normalization
  const path = window.location.pathname.toLowerCase();
  if (path.includes('about')) {
    document.title = 'About Us \u2013 HVACPRIMESUPPLY';
  } else if (path.includes('contact')) {
    document.title = 'Contact \u2013 HVACPRIMESUPPLY';
  } else if (path.includes('faq')) {
    document.title = 'Frequently Asked Questions \u2013 HVACPRIMESUPPLY';
  } else if (path.includes('shipping') || path.includes('delivery')) {
    document.title = 'Shipping & Delivery \u2013 HVACPRIMESUPPLY';
  } else if (path.includes('return') || path.includes('refund')) {
    document.title = 'Returns & Refunds \u2013 HVACPRIMESUPPLY';
  } else if (path.includes('privacy')) {
    document.title = 'Privacy Policy \u2013 HVACPRIMESUPPLY';
  } else if (path.includes('terms')) {
    document.title = 'Terms of Service \u2013 HVACPRIMESUPPLY';
  } else if (path.includes('cookie')) {
    document.title = 'Cookie Policy \u2013 HVACPRIMESUPPLY';
  } else if (path.includes('track')) {
    document.title = 'Track Your Order \u2013 HVACPRIMESUPPLY';
  }
});
